import { render, staticRenderFns } from "./DashboardMarket.vue?vue&type=template&id=f6bc5de6&"
import script from "./DashboardMarket.vue?vue&type=script&lang=js&"
export * from "./DashboardMarket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports